module.exports = __webpack_public_path__ + "img/Referenzen_Overlay.png";